module.exports = __webpack_public_path__ + "img/bg-image-29.0a8f0dff.jpg";